import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';
import { Divider } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2

import { ScrollTypography } from '../../Styles';
import dayjs from 'dayjs';


import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined';


export default function AssignmentAfterCancelled({ AssignmentDetailsAry }) {

    const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;

    return (
        <Box>
            <Box sx={{ mt: 2, ml: { xs: 0, sm: 1 } }}>



                <Typography variant="h5" sx={{ padding:"20px 0px 0px 0px" }} fontWeight="bold" color={appThemeColor}>  {AssignmentDetailsAry.assign_industry} </Typography>



                <Typography variant="h6" fontWeight="bold" color={appThemeColor} sx={{ mt: -1 }}  > {AssignmentDetailsAry.assign_client_name} </Typography>

                {AssignmentDetailsAry.service_type === "InPerson Interpretation" && <Box sx={{ wordWrap: 'break-word', width: '100%', mt: -1 }} >
                    <Typography variant="subtitle2" color={appThemeColor} > {AssignmentDetailsAry.assign_location}</Typography>
                </Box>}




                <Box sx={{ mt: 1 }}>


                    {/* <Grid container > <Grid xs={6} sm={4} md={3}><Typography variant='body2' fontWeight='bold' >Reporting Time</ Typography> </Grid>  <Grid xs={6} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{dayjs(AssignmentDetailsAry.assign_reporting_time).format('hh:mm A [on] MM/DD/YYYY')}</ Typography></Grid> </Grid>

                    <Divider sx={{ borderRadius: '10px' }} /> */}
                    <Grid container > <Grid xs={6} sm={4} md={3}><Typography variant='body2' fontWeight='bold' >Requested Duration</ Typography> </Grid>  <Grid xs={6} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{AssignmentDetailsAry.assign_duration}</ Typography></Grid> </Grid>

                    <Divider sx={{ borderRadius: '10px' }} />
                    <Grid container > <Grid xs={6} sm={4} md={3}><Typography variant='body2' fontWeight='bold' >Type</ Typography> </Grid>  <Grid xs={6} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{AssignmentDetailsAry.service_type_short}</ Typography></Grid> </Grid>

                    <Divider sx={{ borderRadius: '10px' }} />
                    {/* <Grid container > <Grid xs={6} sm={4} md={3}><Typography variant='caption' fontWeight='bold' sx={{ letterSpacing: '-0.2px', whiteSpace: 'nowrap' }}>Requester</ Typography> </Grid>  <Grid xs={6} sm={8} md={9}> <Typography variant='caption' sx={{ letterSpacing: '-0.5px', whiteSpace: 'nowrap' }} color={appThemeColor}>{AssignmentDetailsAry.service_type_short}</ Typography></Grid> </Grid> */}






                    <Grid container > <Grid xs={6} sm={4} md={3}><Typography variant='body2' fontWeight='bold' sx={{ letterSpacing: '-0.2px', whiteSpace: 'nowrap' }}>Requester</ Typography> </Grid>  <Grid xs={6} sm={8} md={9}>
                        {AssignmentDetailsAry.assign_requester_details.new_requester_name === "" && <Box sx={ScrollTypography}> <Typography variant='body2' color={appThemeColor}  >{AssignmentDetailsAry.assign_requester_details.requester_name}</ Typography></Box>}
                        {AssignmentDetailsAry.assign_requester_details.new_requester_name !== "" && <Box sx={ScrollTypography}><Typography variant='body2' color='red' sx={{ textDecoration: 'line-through', mr: 0.5 }}>{AssignmentDetailsAry.assign_requester_details.requester_name}</Typography><Typography variant='body2' color={appThemeColor}>{AssignmentDetailsAry.assign_requester_details.new_requester_name}</Typography></ Box>}
                    </Grid> </Grid>



                    <Divider sx={{ borderRadius: '10px' }} />




                </Box>

            </Box>



            <Box sx={{ mt: 1, display: 'flex', justifyContent: 'center' }}>
                <TranslateOutlinedIcon sx={{ color: appThemeColor, fontSize: '16px', mt: '2px', mr: 0.2 }} /> <Typography color={appThemeColor} variant="caption" sx={{ letterSpacing: '-0.2px' }} > {AssignmentDetailsAry.language_name} | {AssignmentDetailsAry.assign_service_mode}</Typography>
            </Box>




            <Box sx={{ display: 'flex', justifyContent: 'center', ml: { xs: 0, sm: 1, md: 1 }, mb: -2 }}>
                <Typography variant='caption' sx={{ letterSpacing: '-0.2px' }}>Time Zone : {AssignmentDetailsAry.assign_timezone_daylight}</ Typography>
            </Box>
        </Box >
    )
}

